import {HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable, of, catchError, switchMap} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Url} from './url';

export class ApiTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {
  }

  getTranslation(lang: string): Observable<any> {
    return this.getVersion().pipe(
      switchMap((version) =>
        this.http
          .get<Record<string, string>>(`${environment.translationsUrl}/translations/${lang}.json?v=${version}`)
          .pipe(catchError(() => of({}))),
      ),
    );
  }

  private getVersion(): Observable<string> {
    return this.http.get<{ version: number | string }>(`${Url.apiUrl}/translations/version`).pipe(
      switchMap((res) => of(String(res?.version ?? '0'))),
      catchError(() => of('0')),
    );
  }
}
